import { render } from "./FuneralViewFormType3.vue?vue&type=template&id=65e03cc1&lang=true"
import script from "./FuneralViewFormType3.vue?vue&type=script&lang=js"
export * from "./FuneralViewFormType3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__